export * from './advanceSearchSpecimenTransactionTextResult.component';
